<template>
	<div class="logs2">
        <b-modal
            no-close-on-backdrop
            title="Logs Detail"
            class="modal-danger"
            v-model="logDetail"
            @ok="logDetail=false"
            ok-variant="info"
        >
            <b-container fluid>
                <b-row>
                    <b-col>
                        <AgGridVue
                            style="width: 100%; height: 400px; "
                            class="ag-theme-alpine"
                            :pagination="false"
                            :columnDefs="dcolumnDefs"
                            :rowData="drowData"
                            :defaultColDef="defaultColDef"
                        >
                        </AgGridVue>
                    </b-col>
                </b-row>
            </b-container>
        </b-modal>

		<b-container fluid>
			<b-row>
				<b-col>
					<AgGridVue
						style="
							width: calc(100% - 20px);
							height: calc(100vh - 130px);
						"
						class="ag-theme-alpine"
						:pagination="true"
						:paginationPageSize="18"
						:cacheBlockSize="180"
						:columnDefs="columnDefs"
                        :rowData="rowData"
                        :defaultColDef="defaultColDef"
                        @row-double-clicked="onRowDoubleClicked"
					>
					</AgGridVue>
				</b-col>
			</b-row>
		</b-container>
	</div>
</template>
<script>
import { API } from "@/api.js";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-enterprise";

import { LicenseManager } from "ag-grid-enterprise";
LicenseManager.setLicenseKey(window.AG_GRID_LIC);


export default {
	name: "Logs2",
	components: {
		AgGridVue,
	},
	data() {
		return {
            logDetail: false,
            drowData: [],
			dcolumnDefs: [
                {
                    headerName: "Timestamp",
					field: "ts",
					filter: "agDateColumnFilter",
                    valueFormatter: this.dateFormatter,
                    sort: "desc",
				},
				{
					headerName: "Page",
					field: "op",
					filter: "agTextColumnFilter",
				},
			],
            rowData: [],
			filter: "",
			defaultColDef: {
				sortable: true,
				filter: true,
				filterParams: { buttons: ["reset", "apply"] },
				resizable: true, 
			},
			gridApi: null,
			columnApi: null,
			columnDefs: [
                {
                    headerName: "Timestamp",
					field: "ts",
					filter: "agDateColumnFilter",
                    valueFormatter: this.dateFormatter,
                    sort: "desc",
				},
				{
					headerName: "Login",
					field: "login",
					filter: "agSetColumnFilter",
				},
				{
					headerName: "Name",
					field: "name",
					filter: "agSetColumnFilter",
				},
				{
					headerName: "Surname",
					field: "surname",
					filter: "agSetColumnFilter",
				},
				{
					headerName: "Client",
					field: "client",
					filter: "agSetColumnFilter",
				},
				{
					headerName: "IP",
					field: "ip",
					filter: "agTextColumnFilter",
				},
			],
		};
	},
	async mounted() {
        let clients = await API.getClients();
        let cmap = {}
        for(let client of clients)
            cmap[client.code] = client.name;
        let d = await API.getTabella("logs2","where op='login'");
		this.rowData = d.rows.map(r => ({"ts":new Date(r.ts),"login":r.login,"ip":r.ip,"name":r.name,"surname":r.surname, "client": cmap[r.client_code]}))
        // console.log("ROWDATA LOGS",this.rowdata)
	},
    computed: {
    },
	methods: {
        formatter(value) {
            const fmt = new Intl.NumberFormat('it-IT', { style: 'currency',currency: 'EUR',})
            return fmt.format(value)
        },
		dateFormatter(value) {
            console.log(value)
			return value.value.toLocaleString()
		},
		onGridReady(params) {
			// console.log("onGridReady", params);
			this.gridApi = params.api;
			this.columnApi = params.columnApi;
		},
		async onRowDoubleClicked(params){
			// console.log("rowDoubleClicked",params)
			// posso editare solo le righe custom (interventi del cliente)
			console.log(params.data,params.data.ts.toISOString())
            let data = params.data.ts.toISOString()
            // console.log({data})
			// console.log(params.data.datefrom.toISOString().split('T')[0])
            let d = await API.logsdetail(data,params.data.login);
            console.log(d);
            this.drowData = d.map(r => ({"ts": new Date(r.ts),"op": r.op.replace("nav:","")}))
            this.logDetail = true
		},
	},
};
</script>
<style>
div.ag-cell-value {
	text-align: left;;
}
</style>

